/**
 * Seo component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import React from "react";
import { graphql, useStaticQuery } from "gatsby";
import PropTypes from "prop-types";
import { Helmet } from "react-helmet";
import { useEffect } from "react";

const Seo = ({ description, lang, meta, links, title, pageSeo, location, schema }) => {
  meta = [];

  let link = [];
  if (undefined != links) {
    link = [...links];
  }
  // send request if utm_source exists on url
  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const utmSource = queryParams.get("utm_source");
    if (utmSource) {
      sessionStorage.setItem("queryParams", JSON.stringify(Object.fromEntries(queryParams.entries())));
    }
  }, []);
  // END send request if utm_source exists on url

  const { wp, wpUser, site } = useStaticQuery(
    graphql`
      query {
        wp {
          generalSettings {
            title
            description
          }
        }

        # if there's more than one user this would need to be filtered to the main user
        wpUser {
          twitter: name
        }

        site {
          siteMetadata {
            title: title
            siteUrl: url
          }
        }
      }
    `
  );

  const metaDescription = description || wp.generalSettings?.description;
  const defaultTitle = "Orders.co"; // wp.generalSettings?.title

  //// Default Meta Tags
  // // // meta.push({
  // // //   name: `theme-color`,
  // // //   content: `#ff6b00`,
  // // // });
  meta.push({
    name: `msapplication-navbutton-color`,
    content: `#FFFFFF`,
  });
  meta.push({
    name: `apple-mobile-web-app-status-bar-style`,
    content: `#FFFFFF`,
  });
  //// End Default Meta Tags
  let descTitle = title;
  if (!!pageSeo && (pageSeo.seo !== undefined || pageSeo.seo !== null)) {
    // opengraphTitle
    if (!!pageSeo.seo.title) descTitle = pageSeo.seo.title;
    meta.push({
      name: `og:title`,
      content: descTitle,
    });

    // twitterTitle
    let twitterTitle = {
      name: `twitter:title`,
      content: descTitle,
    };
    // if (!!pageSeo.seo.title)
    //   twitterTitle.content = pageSeo.seo.twitterTitle;
    meta.push(twitterTitle);

    //meta description
    let descText = metaDescription;
    if (!!pageSeo.seo.metaDesc) descText = pageSeo.seo.metaDesc;
    meta.push({
      name: `description`,
      content: descText,
    });

    // opengraphDescription
    let ogDescription = {
      name: `og:description`,
      content: descText,
    };
    if (!!pageSeo.seo.opengraphDescription)
      ogDescription.content = pageSeo.seo.opengraphDescription;
    meta.push(ogDescription);

    // twitterDescription
    let twitterDescription = {
      name: `twitter:description`,
      content: descText,
    };
    if (!!pageSeo.seo.twitterDescription)
      twitterDescription.content = pageSeo.seo.twitterDescription;
    meta.push(twitterDescription);

    meta.push({
      name: `twitter:creator`,
      content: wpUser?.twitter || ``,
    });

    // opengraphType
    let ogType = {
      name: `og:type`,
      content: "website",
    };
    if (!!pageSeo.seo.opengraphType) ogType.content = pageSeo.seo.opengraphType;
    meta.push(ogType);

    if (!!pageSeo.uri) {
      link.push({
        rel: 'canonical',
        href: site.siteMetadata.siteUrl + pageSeo.uri
      });
    }

    // Add ogImage
    // Add ogImage
    let ogImageUrl;
    if (!!pageSeo.seo.opengraphImage) {
      ogImageUrl =
        site.siteMetadata.siteUrl +
        pageSeo.seo.opengraphImage.localFile.publicURL;
      meta.push({
        property: `og:image`,
        content: ogImageUrl,
      });
      meta.push({
        property: `og:image:width`,
        content:
          pageSeo.seo.opengraphImage.width,
      });
      meta.push({
        property: `og:image:height`,
        content:
          pageSeo.seo.opengraphImage.height,
      });
      meta.push({
        property: `og:image:type`,
        content: "image/" + pageSeo.seo.opengraphImage.localFile.extension,
      });
    }

    // twitterCard
    let twitterCard = {
      name: `twitter:card`,
      content: `summary`,
    };

    // twitterImage
    if (!!pageSeo.seo.twitterImage) {
      twitterCard.content = "summary_large_image";
      meta.push({
        name: `twitter:image`,
        content:
          site.siteMetadata.siteUrl +
          pageSeo.seo.twitterImage.localFile.publicURL,
      });
    } else {
      if (!!ogImageUrl) {
        twitterCard.content = "summary_large_image";
        meta.push({
          name: `twitter:image`,
          content: ogImageUrl,
        });
      }
    }
    meta.push(twitterCard);
  } else {
    meta.push({
      name: `og:title`,
      content: descTitle,
    });

    // twitterTitle
    meta.push({
      name: `twitter:title`,
      content: descTitle,
    });

    //meta description
    let descText = metaDescription;
    meta.push({
      name: `description`,
      content: descText,
    });

    // opengraphDescription
    meta.push({
      name: `og:description`,
      content: descText,
    });

    // twitterDescription
    meta.push({
      name: `twitter:description`,
      content: descText,
    });
  }
  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={!!descTitle ? descTitle : title}
      titleTemplate={!!descTitle ? null : `%s - ${defaultTitle}`}
      meta={[].concat(meta)}
      link={[].concat(link)}
    >
      {(!!schema && !!schema['@type']) && <script type="application/ld+json">{JSON.stringify(schema)}</script>}
    </Helmet>
  );
};

Seo.defaultProps = {
  lang: `en`,
  meta: [],
  description: ``,
};

Seo.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string.isRequired,
};

export default Seo;
